import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useSelector, useDispatch } from "react-redux"
import {
  Col,
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import { cleanView } from "store/actions"
import showToast from "../../components/Common/viewNotification"
const UploadFileModalMessage = props => {
  const {
    modalOpen,
    toggleModalMsg,
    changeStatus,
    title,
    msg,
    loadFiles,
    currentRow,
  } = props
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { responseDeleteUpload, loading } = useSelector(state => ({
    responseDeleteUpload: state.fileUpload.responseDeleteUpload,
    loading: state.fileUpload.loading,
  }))
  useEffect(() => {
    if (responseDeleteUpload) {
      showToast(t("global:msgSuccessSaveList"), "success", t("global:config"))
      cleanning()
      toggleModalMsg(false)
      loadFiles()
    }
  }, [responseDeleteUpload])
  const cleanning = async () => {
    await dispatch(cleanView())
  }
  return (
    <Modal isOpen={modalOpen} toggle={toggleModalMsg} backdrop={"static"}>
      <ModalHeader toggle={modalOpen} tag="h4" close={<span></span>}>
        {title}
      </ModalHeader>
      <ModalBody>
        <Col>
          <>
            <span className="fw-bold text-uppercase">Nombre Documento:</span>{" "}
            <span className="fw-normal">{currentRow?.fileName}</span>
            <div>
              <span className="fw-bold text-uppercase">{msg}</span>
            </div>
          </>
        </Col>
        <Col>
          <div className="text-end">
            <ButtonGroup>
              <Button
                type="submit"
                className="btn btn-info save-user"
                disabled={loading}
                onClick={changeStatus}
              >
                <i className="fas fa-save me-1"></i>
                {t("global:btnOk")}
              </Button>
              <button
                type="button"
                className="btn btn-danger"
                disabled={loading}
                onClick={() => {
                  toggleModalMsg(false)
                }}
              >
                {t("global:btnCancel")}
              </button>
            </ButtonGroup>
          </div>
        </Col>
      </ModalBody>
    </Modal>
  )
}

export default UploadFileModalMessage
